




import ISiteObjectTranslationDto from "./SiteObjectTranslationDto.if";
import mappings from "./SiteObjectTranslationDto.map";
import IMediumDto from "./MediumDto.if";
import MediumDto from "./MediumDto";
import ILanguageDto from "./LanguageDto.if";
import LanguageDto from "./LanguageDto";
import ISiteObjectDto from "./SiteObjectDto.if";
import SiteObjectDto from "./SiteObjectDto";

import Transformers from './private/transformer';
import DBUtil from './private/db.util';
import { IModelSource } from "./private/db.if";

function _siteObject(this: ISiteObjectTranslationDto, db: IModelSource): Promise<ISiteObjectDto> {
    return DBUtil.loadSiteObjectId<ISiteObjectDto>(db, this.siteObjectId, SiteObjectDto);
}

function _langauge(this: ISiteObjectTranslationDto, db: IModelSource): Promise<ILanguageDto> {
    return DBUtil.loadLanguageId<ILanguageDto>(db, this.languageId, LanguageDto);
}

function _medium(this: ISiteObjectTranslationDto, db: IModelSource): Promise<IMediumDto> {
    return DBUtil.loadMediumId<IMediumDto>(db, this.mediumId, MediumDto);
}

export default (data: object) => { 
    const obj = Transformers.create<ISiteObjectTranslationDto>(mappings, data); 

    /* addLinkables */
    obj.siteObject = _siteObject;
    obj.langauge = _langauge;
    obj.medium = _medium;

    return obj;
}

